import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ACCOUNTING_ENV } from "../../config/micros-env.tokens";
import { EnvMicroAccounting } from "../../config/env.micro.accounting";
import {
  BalanceAdjustment,
  BalanceAdjustmentCreateRequest,
  BalanceAdjustmentFilter,
  BalanceAdjustmentPage,
} from "../../../domain/models/accounting/balance-adjustments.model";
import { BalanceAdjustmentsPort } from "../../../app/ports/accounting/balance-adjustments.port";
import {
  isBalanceAdjustment,
  isBalanceAdjustmentPage,
} from "../../validators/accounting/balance-adjustments.validator";

const INVALID_PAGE = "La respuesta del listado de ajustes de saldo es inválida.";
const INVALID_ADJUSTMENT = "La respuesta del ajuste de saldo es inválida.";

@Injectable()
export class BalanceAdjustmentsHttpAdapter implements BalanceAdjustmentsPort {
  private static readonly PATH = "/api/v1/reconciliation-balance-adjustments";

  constructor(
    private readonly http: HttpClient,
    @Inject(ACCOUNTING_ENV) private readonly env: EnvMicroAccounting,
  ) {}

  list(filter: BalanceAdjustmentFilter): Observable<BalanceAdjustmentPage> {
    let params = new HttpParams().set("limit", filter.limit).set("offset", filter.offset);
    if (filter.idCompany) params = params.set("idCompany", filter.idCompany);
    if (filter.date) params = params.set("date", filter.date);
    if (filter.search) params = params.set("search", filter.search);

    return this.http.get<unknown>(this.url(), { params }).pipe(
      map((response) => {
        if (!isBalanceAdjustmentPage(response)) throw new Error(INVALID_PAGE);
        return response;
      }),
    );
  }

  getById(idAdjustment: number): Observable<BalanceAdjustment> {
    return this.http.get<unknown>(this.url(`/${idAdjustment}`)).pipe(map(toAdjustment));
  }

  create(request: BalanceAdjustmentCreateRequest): Observable<BalanceAdjustment> {
    return this.http.post<unknown>(this.url(), request).pipe(map(toAdjustment));
  }

  private url(suffix = ""): string {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    return `${baseUrl}${BalanceAdjustmentsHttpAdapter.PATH}${suffix}`;
  }
}

function toAdjustment(response: unknown): BalanceAdjustment {
  if (!isBalanceAdjustment(response)) throw new Error(INVALID_ADJUSTMENT);
  return response;
}
